/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReservationRequestReservation
 */
export interface CreateReservationRequestReservation {
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    dateTime: string;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequestReservation
     */
    diners: number;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    customerComments?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    zone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    policy: CreateReservationRequestReservationPolicyEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequestReservation
     */
    policyAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReservationRequestReservation
     */
    notify?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    endTime?: string;
}


/**
 * @export
 */
export const CreateReservationRequestReservationPolicyEnum = {
    Card: 'CARD',
    Deposit: 'DEPOSIT',
    None: 'NONE'
} as const;
export type CreateReservationRequestReservationPolicyEnum = typeof CreateReservationRequestReservationPolicyEnum[keyof typeof CreateReservationRequestReservationPolicyEnum];


/**
 * Check if a given object implements the CreateReservationRequestReservation interface.
 */
export function instanceOfCreateReservationRequestReservation(value: object): value is CreateReservationRequestReservation {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('surname' in value) || value['surname'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('dateTime' in value) || value['dateTime'] === undefined) return false;
    if (!('diners' in value) || value['diners'] === undefined) return false;
    if (!('zone' in value) || value['zone'] === undefined) return false;
    if (!('policy' in value) || value['policy'] === undefined) return false;
    return true;
}

export function CreateReservationRequestReservationFromJSON(json: any): CreateReservationRequestReservation {
    return CreateReservationRequestReservationFromJSONTyped(json, false);
}

export function CreateReservationRequestReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReservationRequestReservation {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'surname': json['surname'],
        'phoneNumber': json['phoneNumber'],
        'email': json['email'],
        'dateTime': json['dateTime'],
        'diners': json['diners'],
        'customerComments': json['customerComments'] == null ? undefined : json['customerComments'],
        'zone': json['zone'],
        'policy': json['policy'],
        'policyAmount': json['policyAmount'] == null ? undefined : json['policyAmount'],
        'notify': json['notify'] == null ? undefined : json['notify'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
    };
}

export function CreateReservationRequestReservationToJSON(json: any): CreateReservationRequestReservation {
    return CreateReservationRequestReservationToJSONTyped(json, false);
}

export function CreateReservationRequestReservationToJSONTyped(value?: CreateReservationRequestReservation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'surname': value['surname'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
        'dateTime': value['dateTime'],
        'diners': value['diners'],
        'customerComments': value['customerComments'],
        'zone': value['zone'],
        'policy': value['policy'],
        'policyAmount': value['policyAmount'],
        'notify': value['notify'],
        'endTime': value['endTime'],
    };
}

